import type { BrandSummary, CampaignReportResponse, DailyMetrics } from "../types";

export function coerceNumber(value: string | number | null | undefined): number {
  if (value === null || value === undefined) {
    return 0;
  }
  if (typeof value === "number") {
    return value;
  }
  const cleaned = value.replace(/[^0-9.-]+/g, "");
  const parsed = Number.parseFloat(cleaned);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatCurrency(
  value: string | number,
  options: Intl.NumberFormatOptions = {},
): string {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 1,
    ...options,
  });
  return formatter.format(coerceNumber(value));
}

export function formatNumber(
  value: string | number,
  options: Intl.NumberFormatOptions = {},
): string {
  const formatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
    ...options,
  });
  return formatter.format(coerceNumber(value));
}

export function extractTrendSeries(
  data: CampaignReportResponse,
  metric: keyof DailyMetrics = "total_sales",
): { label: string; points: { date: string; value: number }[] } {
  const points =
    data.daily_metrics?.map((entry) => ({
      date: entry.report_date,
      value: coerceNumber(entry[metric] as string),
    })) ?? [];

  return {
    label: metric,
    points,
  };
}

export function getTopBrands(
  brands: BrandSummary[],
  metric: keyof BrandSummary = "total_sales",
  limit = 3,
) {
  const sorted = [...brands].sort(
    (a, b) => coerceNumber(b[metric]) - coerceNumber(a[metric]),
  );
  return sorted.slice(0, limit);
}

export function parseCalloutsText(text?: string | null, limit = 3): string[] {
  if (!text) {
    return [];
  }
  return text
    .split(/\n+/)
    .map((line) => line.replace(/^[-*•]\s*/, "").trim())
    .filter(Boolean)
    .slice(0, limit);
}
